import { render } from "./LittleRedDot.vue?vue&type=template&id=0dcfc58c"
import script from "./LittleRedDot.vue?vue&type=script&lang=ts"
export * from "./LittleRedDot.vue?vue&type=script&lang=ts"

import "./LittleRedDot.vue?vue&type=style&index=0&id=0dcfc58c&lang=css"
script.render = render

export default script